export const offers = '/offers'